import React from 'react';
import Handler from './Handler';
import styles from '../../../styles/sessions.scss';

class SessionsDay extends React.Component {
  static defaultProps = {
    disabled: false,
    name: '',
    value: '',
    editable: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      timeFrom: TIME_DAY * this.props.day,
      width: 0,
    };
    this.sessionsContainerRef = React.createRef();
    this.onDeleteTrades = this.onDeleteTrades.bind(this);
    this.onDeleteQuotes = this.onDeleteQuotes.bind(this);
    this.onChangeTrades = this.onChangeTrades.bind(this);
    this.onChangeQuotes = this.onChangeQuotes.bind(this);
    this.onEditStartTrades = this.onEditStartTrades.bind(this);
    this.onEditStartQuotes = this.onEditStartQuotes.bind(this);
    this.onEditStop = this.onEditStop.bind(this);
    this.addSessionQuotes = this.addSessionQuotes.bind(this);
    this.addSessionTrades = this.addSessionTrades.bind(this);
  }

  componentDidMount() {
    let container = this.sessionsContainerRef.current;
    let clientRect = container.getClientRects()[0];
    this.setState({
      width: clientRect.width,
      left: clientRect.left,
    });
  }

  onDeleteTrades(index) {
    this.props.onDelete('Trades', index);
  }

  onDeleteQuotes(index) {
    this.props.onDelete('Quotes', index);
  }

  onChangeTrades(index, name, value) {
    this.props.onChange('Trades', index, name, value);
  }

  onChangeQuotes(index, name, value) {
    this.props.onChange('Quotes', index, name, value);
  }

  onEditStartTrades(index, name) {
    this.props.onEditStart('Trades', index, name);
  }

  onEditStartQuotes(index, name) {
    this.props.onEditStart('Quotes', index, name);
  }

  onEditStop() {
    this.props.onEditStop();
  }

  addSessionQuotes(e) {
    this.addSession('Quotes', e);
  }

  addSessionTrades(e) {
    this.addSession('Trades', e);
  }

  addSession(type, e) {
    let position = e.pageX;
    let left = this.state.left;
    let width = this.state.width;
    let x = (position - left);
    let value = Math.round(x / width * TIME_DAY) + this.state.timeFrom;

    this.props.onAddSession(type, value);
  }

  render() {
    let divisions = [];

    for (let i = 1; i <= 23; i++) {
      let left = (100 / 24 * i).toFixed(2);
      divisions.push(<div key={i} className={styles["sessions-division"]} style={{left: left + "%"}}><span></span>
      </div>);
    }

    let handlers = [];

    for (let i = 0; i < this.props.values.length; i++) {
      let item = this.props.values[i];
      if (item.From >= this.state.timeFrom && item.To <= this.state.timeFrom + TIME_DAY && item.Type !== Constants.Diff) {
        handlers.push(<Handler type={this.props.type}
                               editable={this.props.editable}
                               index={i}
                               key={'from-' + i}
                               from={item.From}
                               to={item.To}
                               containerWidth={this.state.width}
                               containerLeft={this.state.left}
                               timeFrom={this.state.timeFrom}
                               editing={this.props.editing.Quotes}
                               onDelete={this.onDeleteQuotes}
                               onChange={this.onChangeQuotes}
                               onEditStart={this.onEditStartQuotes}
                               onEditStop={this.onEditStop}
        />);
      }
    }

    return (
      <div className={styles["sessions-line"]} ref={this.sessionsContainerRef}>
        <div className={styles["sessions-divisions"]}
             onDoubleClick={this.props.editable ? this.addSessionQuotes : null}>{divisions}</div>
        {handlers}
      </div>
    );
  }
}

export default SessionsDay;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/Day.jsx